import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";

export default function ScanImage({ scanId, className }) {
  const api = useApi();
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api("get", `/scans/${scanId}/image`, undefined, { responseType: "blob" })
      .then((b) => { url = URL.createObjectURL(b); setSrc(url); })
      .catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [api, scanId]);
  return src ? <img src={src} alt="Foto frigo" className={className} /> : <div className={`${className} animate-pulse bg-[#E8F3EA]`} />;
}
